const routes = [
  {
    path: '/shippedRefund',
    name: 'shippedRefund',
    meta: {
      title: '选择售后类型',
      login: false,
    },
    component: () => import(/* webpackChunkName: 'appHomeSecondaryPage' */ './page/shippedRefund'),
  },
  {
    path: '/submitRefund',
    name: 'submitRefund',
    meta: {
      title: '申请退款',
      login: false,
    },
    component: () => import(/* webpackChunkName: 'appHomeSecondaryPage' */ './page/submitRefund'),
  },
  {
    path: '/refundSchedule',
    name: 'refundSchedule',
    meta: {
      title: '退款/售后进度',
      login: false,
    },
    component: () => import(/* webpackChunkName: 'appHomeSecondaryPage' */ './page/refundSchedule'),
  }
];

export default routes;
